<template>
  <v-container
    style="margin-left: -25px;
    margin-top: -20px;"
  >
    <h2 class="page-title-bar">
      <i class="ico ico-system"></i>{{ $t("PDA Settings") }}
    </h2>
    <v-tabs
      v-model="tab"
      background-color="#001e38" color="#fff"
      class="mt-6 custom-tabs"
      grow
    >
      <v-tab href="#esl">{{ $t("ESL PACKAGE") }}</v-tab>
      <v-tab href="#qr">{{ $t("GENERATE QR") }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item value="esl" class="ml-5">
        <!-- Dynamic Function Groups -->
        <div v-for="group in visibleFunctionGroups" :key="group.key">
          <v-row>
            <v-col cols="12">
              <h3 class="group-title">{{ group.title }}</h3>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col
              v-for="(item, i) in group.items"
              :key="i"
              cols="6"
              sm="4"
              md="4"
              lg="2"
              style="padding: 4px;"
            >
              <v-card
                outlined
                class="function-card d-flex align-center pa-6 text-center elevation-4"
                :class="{ selected: item.state, unselected: !item.state }"
                @click="toggleSelect(group.key, i)"
              >
                <div class="icon-container">
                  <v-icon v-if="item.state" color="#001E38"
                    >mdi-check-circle</v-icon
                  >
                  <v-icon v-else>mdi-radiobox-blank</v-icon>
                </div>
                <div class="card-content">
                  <!-- SVG Icon -->
                  <div>
                    <img
                      :src="require(`@/assets/icons/${item.svg}`)"
                      :alt="item.label"
                      class="custom-icon"
                      :class="{ 'mt-2 ml-0' : item.name === 'VISION_ASSIGN' }"
                      :style="{ width: item.name === 'VISION_ASSIGN' ? '50px' : '70px' }"
                    />
                  </div>
                  <span class="text-caption" style="font-weight: 600;">{{
                    item.label
                  }}</span>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <!-- Save Button -->
        <v-row class="mt-8">
          <v-col cols="12" class="text-left">
            <v-btn
              :disabled="PDAButtonConfigSave"
              class="btn"
              text
              @click="PDAConfigSave"
            >
              {{ $t("Save") }}</v-btn
            >
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item value="qr">
    <v-row class="mt-6 ml-2 mr-4" no-gutters>
      <!-- Form Card -->
      <v-col cols="12" md="5">
        <v-card class="qr-form-card pa-6" elevation="2">
          <div class="qr-form-header mb-5">
            <v-icon color="#001E38" class="mr-2">mdi-qrcode-plus</v-icon>
            <span class="qr-form-title">{{ $t("QR Configuration") }}</span>
          </div>
          <v-divider class="mb-5" />
          <v-select
            v-model="facility"
            :items="storeList"
            item-text="code"
            return-object
            :placeholder="$t('Select Facility')"
            class="form-input rowPerPage mb-1"
            :label="$t('Facility *')"
            dense
            persistent-hint
            outlined
            hide-details
            prepend-inner-icon="mdi-store"
          />
          <v-text-field
            v-model="username"
            persistent-placeholder
            :placeholder="$t('Input User Name')"
            :label="$t('User Name *')"
            class="form-input mt-4"
            outlined
            hide-details
            dense
            clearable
            prepend-inner-icon="mdi-account-outline"
          />
          <v-text-field
            v-model="password"
            persistent-placeholder
            :placeholder="$t('Input Password')"
            :label="$t('Password *')"
            class="form-input mt-4"
            outlined
            hide-details
            dense
            clearable
            prepend-inner-icon="mdi-lock-outline"
            type="password"
          />
          <v-btn
            class="btn qr-generate-btn mt-6"
            block
            :disabled="PDAButtonConfigSave"
            @click="handleGenerateQr"
          >
            <v-icon left small>mdi-qrcode-scan</v-icon>
            {{ $t("Generate QR") }}
          </v-btn>
        </v-card>
      </v-col>

      <!-- QR Preview Card -->
      <v-col cols="12" md="5" class="pl-md-6 pt-6 pt-md-0">
        <v-card class="qr-preview-card pa-6" elevation="2">
          <div class="qr-form-header mb-5">
            <v-icon color="#001E38" class="mr-2">mdi-qrcode</v-icon>
            <span class="qr-form-title">{{ $t("QR Preview") }}</span>
          </div>
          <v-divider class="mb-5" />
          <div class="qr-preview-area">
            <template v-if="encodedImage">
              <img class="qr-image" :src="encodedImage" alt="QR Code" />
            </template>
            <template v-else>
              <div class="qr-empty-state">
                <v-icon size="72" color="#ccc">mdi-qrcode</v-icon>
                <p class="qr-empty-text mt-3">
                  {{
                    $t("Fill in the form and click Generate QR to preview")
                  }}
                </p>
              </div>
            </template>
          </div>
        </v-card>
      </v-col>
    </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>
<script>
// import config from '@/plugins/configs'
import codes from '@/plugins/codes'
import EventBus from '@/plugins/eventBus.js'
import configs from '@/plugins/configs.js'

// import commons from '@/plugins/commons'
export default {
  data () {
    return {
      tab: 'esl',
      facility: '',
      username: '',
      password: '',
      encodedImage: '',
      functionGroups: [
        {
          key: 'assignFunctions',
          title: 'ASSIGN FUNCTION',
          items: [
            { label: this.$t('Assign'), name: 'ESL_ASSIGN', svg: 'Assign.svg', state: true },
            { label: this.$t('Multi Assign'), name: 'ESL_MULTIASSIGN', svg: 'Multi_Assign.svg', state: true },
            { label: this.$t('Unassign'), name: 'ESL_UNASSIGN', svg: 'Unassign.svg', state: true },
            { label: this.$t('Extra Info Assign'), name: 'ESL_EXTRAINFOASSIGN', svg: 'extra_assign.svg', state: true },
            { label: this.$t('Assign with Template'), name: 'ASSIGN_WITH_TEMPLATE', svg: 'Assign_with_Template.svg', state: true }
          ]
        },
        {
          key: 'defaultFunctions',
          title: 'DEFAULT FUNCTION',
          items: [
            { label: this.$t('Product Info'), name: 'ESL_PRODUCTINFO', svg: 'Product_Info.svg', state: true },
            { label: this.$t('Label Info'), name: 'ESL_LABELINFO', svg: 'Label_Info.svg', state: true },
            { label: this.$t('Blinking by Product'), name: 'ESL_BLINKINGBYPRODUCT', svg: 'Blinking_by_Product.svg', state: true },
            { label: this.$t('Blinking by Label'), name: 'ESL_BLINKINGBYLABEL', svg: 'Blinking_by_Label.svg', state: true },
            { label: this.$t('Page Flipping'), name: 'ESL_PAGEFLIPPING', svg: 'Page_Flipping.svg', state: true }
          ]
        },
        {
          key: 'powerRail',
          title: 'POWER RAIL',
          items: [
            { label: this.$t('Assign'), name: 'POWER_RAIL_ASSIGN', svg: 'PowerRailAssign.svg', state: true },
            { label: this.$t('Unassign'), name: 'POWER_RAIL_UNASSIGN', svg: 'PowerRailUnAssign.svg', state: true }
          ]
        },
        {
          key: 'sensor',
          title: 'SENSOR',
          items: [
            { label: this.$t('Assign'), name: 'SENSOR_ASSIGN', svg: 'SensorAssign.svg', state: true },
            { label: this.$t('Unassign'), name: 'SENSOR_UNASSIGN', svg: 'SensorUnAssign.svg', state: true }
          ]
        },
        {
          key: 'vision',
          title: 'VISION',
          items: [
            { label: this.$t('Assign'), name: 'VISION_ASSIGN', svg: 'VisionAssign.svg', state: true }
          ]
        }
      ],
      PDAButtonConfigSave: false,
      showVision: false,
      showSensor: false
    }
  },
  mounted () {
    // // PDA Button Config : Save
    this.$store.dispatch('auth/getDisabledBtn', '9601').then(flag => {
      this.PDAButtonConfigSave = flag
    })
    this.togetPDAConfigButtonState()
  },
  computed: {
    storeList () {
      return this.$store.getters['dataStore/GET_STORE_ITEMS']
    },
    visibleFunctionGroups () {
      return this.functionGroups.filter(group => {
        if (group.key === 'powerRail' || group.key === 'sensor') return this.showSensor
        if (group.key === 'vision') return this.showVision
        return true
      })
    }
  },
  methods: {
    handleGenerateQr () {
      if (!this.facility) {
        EventBus.$emit('messageAlert', this.$t('Please select the facility.'), 'error')
        return
      }
      if (!this.username) {
        EventBus.$emit('messageAlert', this.$t('Please enter the username.'), 'error')
        return
      }

      if (!this.password) {
        EventBus.$emit('messageAlert', this.$t('Please enter the password.'), 'error')
        return
      }

      const protocolAndHost = configs.ServerAddress.split(':')
      const protocol = protocolAndHost[0]
      const ipdomain = protocolAndHost[1].split('//')[1]
      const port = protocolAndHost[2]
      const config = { params: {} }
      const data = {
        username: this.username,
        password: this.password,
        ipdomain: ipdomain,
        port: port,
        protocol: protocol,
        server: configs.keycloakLogin ? 'AIMS_Security' : 'AIMS',
        selectedDocker: process.env.BASE_URL.includes('/Dashboard') ? 'Disable' : 'Enable',
        storecode: this.facility.code
      }
      this.$utils.callAxiosWithBody(codes.requests.toGenerateQr.method, codes.requests.toGenerateQr.url, data, config).then(res => {
        const result = res.data
        if (result.responseCode === '200') {
          this.encodedImage = result.qrCodeBase64
          EventBus.$emit('messageAlert', this.$t(result.responseMessage))
        } else {
          EventBus.$emit('messageAlert', this.$t(result.responseMessage))
        }
      })
    },
    toggleSelect (groupKey, index) {
      const group = this.functionGroups.find(g => g.key === groupKey)
      if (group) group.items[index].state = !group.items[index].state
    },
    togetPDAConfigButtonState () {
      const config = { params: {} }
      this.$utils
        .callAxios(
          codes.requests.getPdaButtons.method,
          codes.requests.getPdaButtons.url,
          config
        )
        .then(res => {
          const result = res.data
          if (result.responseCode !== 200) {
            console.warn('Failed to fetch PDA configuration:', result.responseMessage)
            return
          }
          const buttonStates = result.data?.buttonConfiguration || []
          this.functionGroups.forEach(group => {
            group.items.forEach(item => {
              const matchedButton = buttonStates.find(b => b.name === item.name)
              if (matchedButton) {
                item.state = matchedButton.state
              }
            })
          })
        })
        .catch(error => {
          console.warn('Could not load PDA configuration:', error)
        })
    },

    PDAConfigSave () {
      const buttonConfiguration = this.functionGroups.flatMap(group =>
        group.items.map(item => ({
          name: item.name,
          state: item.state
        }))
      )
      const data = { buttonConfiguration }
      const config = { params: {} }
      if (!buttonConfiguration.length) {
        EventBus.$emit('messageAlert', this.$t('No buttons to save.'))
        return
      }
      this.$utils
        .callAxiosWithBody(
          codes.requests.updatePdaButtons.method,
          codes.requests.updatePdaButtons.url,
          data,
          config
        )
        .then(res => {
          const result = res.data
          if (result.responseCode === 200) {
            EventBus.$emit('messageAlert', this.$t('Saved successfully'))
            this.togetPDAConfigButtonState()
          } else {
            EventBus.$emit('messageAlert', this.$t(result.responseMessage))
          }
        })
        .catch(error => {
          const message =
            error?.response?.data?.responseMessage || 'Something went wrong'
          EventBus.$emit('messageAlert', this.$t(message))
        })
    }
  },
  created () {
    this.showVision = this.$store.state.auth.user.visionEnable === 'true'
    this.showSensor = this.$store.state.auth.user.sensorEnable === 'true'
  }
}
</script>
<style scoped>
.qr-form-card,
.qr-preview-card {
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  height: 410px;
}
.qr-form-header {
  display: flex;
  align-items: center;
}
.qr-form-title {
  font-size: 15px;
  font-weight: 700;
  color: #001e38;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.qr-generate-btn {
  font-weight: 600;
  letter-spacing: 0.5px;
}
.qr-preview-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}
.qr-image {
  width: 260px;
  height: 260px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.qr-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.qr-empty-text {
  color: #aaa;
  font-size: 13px;
  max-width: 220px;
  line-height: 1.5;
}
.qr-actions {
  display: flex;
  gap: 8px;
}
.page-title-bar {
  display: flex;
  align-items: center;
  gap: 8px;
}
.group-title {
  word-spacing: 3px;
  font-size: var(--font18);
  line-height: 1.5;
  color: #001e38;
}
.function-card {
  border-radius: 20px;
  height: 90px;
  width: 200px;
  cursor: pointer;
  transition: all 0.2s;
}
.function-card.selected {
  border: 2px solid #09263f;
  opacity: 1;
}
.function-card.unselected {
  opacity: 0.3;
}
.function-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}
.icon-container {
  width: 15%;
}
.card-content {
  display: flex;
  flex-direction: column;
  width: 85%;
  align-items: center;
}
.custom-icon {
  margin-bottom: 4px;
  width: 70px;
  margin-left: 25px;
}
.custom-tabs {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
}
::v-deep .v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active) {
  background-color: #e7eaec !important;
  color: #999 !important;
}
@media (min-width: 1264px) {
  .col-lg-2 {
    max-width: 18%;
  }
}
</style>
